// src/components/store/sections/blog-posts/BlogV47GlassauroraCrimsonRose.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV47GlassauroraCrimsonRose(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={47}
      archKey="glass_aurora"
      archLabel="Frosted Glass Stories"
      palName="CrimsonRose"
      grad="from-rose-500 via-pink-600 to-red-600"
      lightBg="bg-rose-50"
      textCol="text-rose-700"
      borderCol="border-rose-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f43f5e"
      {...props}
    />
  );
}
